import { z } from 'zod'
import { GenericActionData } from '~/utils/clientValidation'
import { inferSafeParseErrors } from '~/utils/inferSafeParseErrors'

export const schema = z.object({
  preferedname: z.string().optional(),
  firstName: z
    .string()
    .pipe(
      z
        .string()
        .trim()
        .min(2, 'Please enter your first name')
        .max(40, 'Please enter less than 40 characters.'),
    ),
  lastName: z
    .string()
    .pipe(
      z
        .string()
        .trim()
        .min(1, 'Please enter your last name')
        .max(40, 'Please enter less than 40 characters.'),
    ),
  emailID: z
    .string()
    .email('Please enter a valid email address.')
    .max(70, 'Please enter less than 70 characters.'),
  newApp: z.string().optional(),
})

export type SchemaFields = z.infer<typeof schema>
export type SchemaFieldsErrors = inferSafeParseErrors<typeof schema>
export type ActionData = GenericActionData<SchemaFields, SchemaFieldsErrors>
